/**
 * 오더목록 기종 상세검색 — $j.F.Order.CarDetail
 *
 * 업종 <select>(#c) 의 '기종 상세검색' 을 고르면 3단(업종 > 분류1 > 분류2) 모달이 뜬다.
 * 예) 크레인 > 하이드로 > 50T,  스카이 > 1T > 16m
 *
 * 고른 기종은 hidden #cr 에 오더의 car_range 와 같은 형식으로 담긴다.
 *   크레인>하이드로>50T → '334'     (기종코드 하나)
 *   스카이>1T>16m       → '100|16'  (기종코드|미터)
 * 서버(OrderListService → CarCodeService::orderRangeSearchSql)가 이 값을 오더의 기종 '범위' 와
 * 대조한다. 오더는 '520~526' 처럼 범위로 발주되므로 그 범위 안에 들어가면 잡힌다.
 *
 * 장비 선택 UI 는 기사관리 '장비추가' 와 같은 $j.F.CarSelect 를 쓰되, 전고·차량번호·옵션은
 * idList 에서 빼서 3단계만 남긴다 (CarSelect 는 idList 에 없는 칸을 조용히 건너뛴다).
 */
export default class CarDetail {

    /** 업종 <select> 에서 이 값을 고르면 모달이 열린다 (blade 의 option value 와 계약) */
    static OPT = '__detail__';

    static MODAL_ID = 'car-detail-modal';

    /**
     * 상세검색 모달 열기.
     * @param {object} host 페이지 인스턴스 ($j.p) — 적용 후 doSearch() 를 부른다
     */
    static open(host) {
        // 상세가 걸려 있으면 셀렉트는 숨어 있어도 값(업종)은 그대로 들고 있다
        const carType = $('#c').val();

        $j.Ui.JBModal.html(this.MODAL_ID, `
            <div class="cd-detail">
                <div class="alert alert-info py-2" style="font-size:12.5px">
                    기종을 <b>3단계</b>까지 고르면 그 기종으로 발주된 오더만 검색합니다.
                    범위로 발주된 오더(예: 미니 <b>020~035</b>)는 고른 기종이 범위 안에 들면 함께 나옵니다.
                </div>
                <div style="text-align:center;padding:10px 0">
                    <select id="cd-cartype" class="inftx" style="height:32px;min-width:100px"></select>
                    <select id="cd-depth1"  class="inftx" style="height:32px;min-width:110px"></select>
                    <select id="cd-depth2"  class="inftx" style="height:32px;min-width:110px"></select>
                </div>
                <div class="text-right" style="margin-top:20px">
                    <button type="button" class="btn btn-sm btn-default" id="cd-clear">상세검색 해제</button>
                    <button type="button" class="btn btn-sm btn-primary" id="cd-apply">적용</button>
                </div>
            </div>`, '기종 상세검색', { width: '520px' });

        // 이전 선택 복원 — car_range 가 있으면 CarSelect 가 3칸을 되짚어 채운다
        $j.F.CarSelect.initialize({
            idList: { car_type: 'cd-cartype', depth1: 'cd-depth1', depth2: 'cd-depth2' },
            v: { car_type: carType === this.OPT ? '' : carType, car_range: $('#cr').val() || '' },
        });

        $('#cd-apply').on('click', () => this.apply(host));
        $('#cd-clear').on('click', () => {
            this.clear();
            $j.Ui.JBModal.close(this.MODAL_ID);
            host.doSearch();
        });
    }

    /** 모달의 '적용' — 업종(#c)과 상세기종(#cr)을 채우고 바로 검색한다. */
    static apply(host) {
        const s = $j.F.CarSelect;
        const carType = s.getCarType();
        if (!carType)                    { $j.F.Admin.Util.tsalert('warning', '업종을 선택해주세요.'); return; }
        if (!s.getDepth1() || !s.getDepth2()) { $j.F.Admin.Util.tsalert('warning', '기종을 3단계까지 선택해주세요.'); return; }

        const label = [carType,
                       $('#cd-depth1 option:selected').text(),
                       $('#cd-depth2 option:selected').text()].join(' › ');

        $('#c').val(carType);
        $('#cr').val(s.getCarRange()).data('label', label);
        this.sync();

        $j.Ui.JBModal.close(this.MODAL_ID);
        host.doSearch();
    }

    /** 상세검색 해제 (업종 자체는 그대로 둔다). */
    static clear() {
        $('#cr').val('').removeData('label');
        if ($('#c').val() === this.OPT) $('#c').val('');
        this.sync();
    }

    /**
     * hidden(#cr) 값에 맞춰 업종칸을 갱신한다.
     * 상세기종이 걸려 있으면 업종 <select> 를 숨기고 **그 자리에** 칩을 세운다 — 한 칸이 한 조건.
     */
    static sync() {
        const v = $('#cr').val();
        const $badge = $('#cr-badge');
        if (!$badge.length) return;

        if (!v) {
            $badge.hide();
            $('#c').show();
            return;
        }
        $badge.css('display', 'inline-flex')
              .attr('title', $('#cr').data('label') || v)
              .find('.cr-badge-text').text($('#cr').data('label') || v);
        $('#c').hide();
    }

    /**
     * 업종 셀렉트·뱃지 이벤트 바인딩. 페이지 initHandler 에서 1회 호출.
     * @param {object} host 페이지 인스턴스 ($j.p)
     */
    static bind(host) {
        const self = this;

        $('#c').off('.carDetail')
            // 목록을 펼치기 전 값을 붙들어 둔다 — '상세검색'을 고르면 이 값으로 되돌린다
            .on('focus.carDetail mousedown.carDetail', function () {
                if (this.value !== self.OPT) $(this).data('prev', this.value);
            })
            .on('change.carDetail', function () {
                if (this.value === self.OPT) {
                    // '상세검색'이 셀렉트에 남으면 그대로 서버로 나간다 — 직전 업종으로 되돌리고 모달만 연다
                    this.value = $(this).data('prev') || '';
                    self.open(host);
                    return;
                }
                self.clear();   // 업종을 직접 고르면 상세조건은 버린다
            });

        $('#cr-badge').off('.carDetail')
            // 칩 본문 클릭 = 다시 고르기 (셀렉트가 숨어 있어 여기가 유일한 재진입로다)
            .on('click.carDetail', '.cr-badge-text', function () { self.open(host); })
            .on('click.carDetail', '.cr-badge-x', function () {
                self.clear();
                host.doSearch();
            });

        this.sync();
    }
}
